import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import "./Infographic.scss";

function Infographic() {
  const container = useRef();
  const windowsRef = useRef();

  useEffect(() => {
    const window = gsap.utils.selector(windowsRef);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container.current,
        start: "top 75%",
        once: true,
        end: "top 75%",
      },
    });
    tl.fromTo(
      window(".cls-2I"),
      {
        opacity: 0,
        scale: 0.5,
        transformOrigin: "50% 50%",
      },
      {
        opacity: 1,
        scale: 1,
        duration: 1,
        stagger: 0.1,
        transformOrigin: "50% 50%",
      }
    )
      .fromTo(
        "#num87",
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.7,
        },
        "-=.3"
      )
      .fromTo(
        "#num89",
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.7,
        },
        "-=.3"
      )
      .fromTo(
        "#num88",
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.7,
        },
        "-=.3"
      );
  }, []);

  return (
    <figure className="infographic-section2">
      <div className="infographic__graphic">
        <div className="graphic__section" ref={container}>
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 45 46"
            className="graphic__icon"
          >
            <path
              className="cls-1I"
              d="M44.64,22l-4.31-4.39V4.26a1.21,1.21,0,0,0-1.19-1.21H33a1.21,1.21,0,0,0-1.19,1.21V9L23.37.37a1.19,1.19,0,0,0-1.72,0L.39,22a1.2,1.2,0,0,0,.81,2.08H5.45V44.74A1.26,1.26,0,0,0,6.69,46h31.7a1.26,1.26,0,0,0,1.24-1.26V24.09h4.2A1.21,1.21,0,0,0,44.64,22Z"
              transform="translate(0 0)"
            />
            <g id="windows" ref={windowsRef}>
              <rect
                className="cls-2I"
                x="24.13"
                y="23.92"
                width="6.46"
                height="6.57"
              />
              <rect
                className="cls-2I"
                x="14.44"
                y="23.92"
                width="6.46"
                height="6.57"
              />
              <rect
                className="cls-2I"
                x="14.44"
                y="33.78"
                width="6.46"
                height="6.57"
              />
              <rect
                className="cls-2I"
                x="24.13"
                y="33.78"
                width="6.46"
                height="6.57"
              />
            </g>
          </svg>

          <p className="graphic__section__number" id="num87">
            87%
          </p>
          <p className="graphic__section__copy">
            of buyers relied on a real estate agent for their home search
          </p>
          <p className="graphic__section__number" id="num89">
            89%
          </p>
          <p className="graphic__section__copy">
            of buyers were very satisfied with their agent’s knowledge of the
            purchase process
          </p>
          <p className="graphic__section__number" id="num88">
            88%
          </p>
          <p className="graphic__section__copy">
            of buyers were very satisfied with their agent’s knowledge of the
            purchase process
          </p>
        </div>
      </div>
      <figcaption className="captions">
        Source: NAR 2021 Profile of Home Buyers and Sellers
      </figcaption>
    </figure>
  );
}

export default Infographic;
